import {
  BuyIcon,
  DashboardIcon,
  DocIcon,
  NFTIcon,
  SettingsIcon,
  SwapIcon,
  OperateIcon,
  TransactionIcon,
  WalletIcon,
} from "@cividao/components/icons"

export const NAVIGATION_KEYS = {
  DASHBOARD: "dashboard",
  OPERATE: "operate",
  MORE: "more",
} as const

export type NavigationKeys = (typeof NAVIGATION_KEYS)[keyof typeof NAVIGATION_KEYS]

export const SUB_NAVIGATION_KEYS = {
  BUY: "buy",
  SWAP: "swap",
  WALLET: "wallet",
  NFTS: "nfts",
  DOCS: "docs",
  SETTINGS: "settings",
} as const

export const SUB_NAVIGATION_MAP: Record<NavigationKeys, SubNavigationKeys[]> = {
  [NAVIGATION_KEYS.DASHBOARD]: [],
  [NAVIGATION_KEYS.OPERATE]: [SUB_NAVIGATION_KEYS.BUY, SUB_NAVIGATION_KEYS.SWAP],
  [NAVIGATION_KEYS.MORE]: [
    SUB_NAVIGATION_KEYS.WALLET,
    SUB_NAVIGATION_KEYS.NFTS,
    SUB_NAVIGATION_KEYS.DOCS,
    SUB_NAVIGATION_KEYS.SETTINGS,
  ],
}

export type SubNavigationKeys = (typeof SUB_NAVIGATION_KEYS)[keyof typeof SUB_NAVIGATION_KEYS]

export type AllNavigationKeys = NavigationKeys | SubNavigationKeys

export const NAVIGATION_ICONS: Record<NavigationKeys | SubNavigationKeys, React.JSX.Element> = {
  [NAVIGATION_KEYS.DASHBOARD]: <DashboardIcon />,
  [NAVIGATION_KEYS.OPERATE]: <OperateIcon />,
  [NAVIGATION_KEYS.MORE]: <TransactionIcon />,
  [SUB_NAVIGATION_KEYS.BUY]: <BuyIcon />,
  [SUB_NAVIGATION_KEYS.SWAP]: <SwapIcon />,
  [SUB_NAVIGATION_KEYS.WALLET]: <WalletIcon />,
  [SUB_NAVIGATION_KEYS.NFTS]: <NFTIcon />,
  [SUB_NAVIGATION_KEYS.DOCS]: <DocIcon />,
  [SUB_NAVIGATION_KEYS.SETTINGS]: <SettingsIcon />,
}

export const NAVIGATION_ROUTES: Record<AllNavigationKeys, string> = {
  [NAVIGATION_KEYS.DASHBOARD]: "/",
  [NAVIGATION_KEYS.OPERATE]: "",
  [NAVIGATION_KEYS.MORE]: "",
  [SUB_NAVIGATION_KEYS.BUY]: "buy",
  [SUB_NAVIGATION_KEYS.SWAP]: "swap",
  [SUB_NAVIGATION_KEYS.WALLET]: "wallet",
  [SUB_NAVIGATION_KEYS.NFTS]: "nfts/info",
  [SUB_NAVIGATION_KEYS.DOCS]: "",
  [SUB_NAVIGATION_KEYS.SETTINGS]: "",
}
